// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LAYj","rootMobile":"styles_rootMobile__1Kmhe"};